import * as $ from 'jquery';

export class AutoLogin {
    constructor() {

    }

    tryLogin(): boolean {
        const urlParams = new URLSearchParams(window.location.search);
        const username = urlParams.get('username');
        const password = urlParams.get('password');

        if (username && password) {
            var $username = $('.login-name-input');
            var $password = $('.login-password-input');
            var $button = $('.login-page-btn');
            $username.val(username);
            $password.val(password);
            $button.trigger('click');
            return true;
        }
        return false;
    }
}